import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/success.svg` */
export const SuccessSolidIcon = createTripletGlyphIcon('SuccessSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="currentColor" />
      <path
        d="M10.5254 5.71191C10.7401 5.49736 11.088 5.49737 11.3027 5.71191C11.5174 5.92665 11.5173 6.27448 11.3027 6.48926L7.54785 10.2451C7.31432 10.4787 6.93758 10.4853 6.69629 10.2598L4.70996 8.40137C4.48851 8.19381 4.47717 7.84572 4.68457 7.62402C4.89208 7.40257 5.2402 7.39136 5.46191 7.59863L7.10254 9.13379L10.5254 5.71191Z"
        fill="white"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="9" fill="#387D64" />
      <path
        d="M11.8896 6.47461C12.1044 6.25997 12.4522 6.25999 12.667 6.47461C12.8817 6.68937 12.8817 7.03718 12.667 7.25195L8.44238 11.4775C8.20583 11.7139 7.82438 11.7206 7.58008 11.4922L5.3457 9.40137C5.12426 9.1938 5.11292 8.84571 5.32031 8.62402C5.52783 8.40253 5.87593 8.39131 6.09766 8.59863L7.99219 10.3711L11.8896 6.47461Z"
        fill="white"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#387D64" />
      <path
        d="M15.8408 8.62109C16.1337 8.32833 16.6085 8.32828 16.9014 8.62109C17.1941 8.91395 17.1941 9.38877 16.9014 9.68164L14.085 12.4985L11.2686 15.3154C10.9468 15.637 10.428 15.6457 10.0957 15.335L7.11621 12.5479C6.81412 12.2649 6.79851 11.7907 7.08105 11.4883C7.36403 11.1858 7.83912 11.1701 8.1416 11.4531L10.6562 13.8057L15.8408 8.62109Z"
        fill="white"
      />
    </svg>
  ),
});
